import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LogCallRoutingModule} from './log-call-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../shared';
import {
  NgZorroAntdModule,
  NzMenuModule,
} from 'ng-zorro-antd';
import {
  LogCallComponent,
  LogCallTicketComponent,
  LogCallTimeComponent,
  LogCallRepostComponent,
  NoteModalComponent
} from './';
import {CallModule} from '../customers/call/call.module';


@NgModule({
  declarations: [
    LogCallComponent,
    LogCallTicketComponent,
    LogCallTimeComponent,
    LogCallRepostComponent,
    NoteModalComponent],
    imports: [
        CommonModule,
        LogCallRoutingModule,
        NzMenuModule,
        FormsModule,
        NgZorroAntdModule,
        ReactiveFormsModule,
        SharedModule,
        CallModule
    ]
})
export class LogCallModule {
}
